import React from 'react';
import Icon from '../Icon';
import type { ShipmentsPageView } from '../../hooks/useProcurementBar';
import '../../styles/components/Header.css';

interface Props {
  view: ShipmentsPageView;
  /** Shipments with goods waiting to be received; shown on the second tab when there are any. */
  readyCount: number;
  onChange: (view: ShipmentsPageView) => void;
}

/** The view switch in the Shipments breadcrumb bar, styled like the Bundles table/card switch. */
const ShipmentsViewTabs: React.FC<Props> = ({ view, readyCount, onChange }) => (
  <div className="header-toolbar-tabs" role="tablist" aria-label="Shipments view">
    <button type="button" role="tab" aria-selected={view === 'table'} className={`header-toolbar-tab${view === 'table' ? ' active' : ''}`} onClick={() => onChange('table')} title="Table view">
      <Icon name="list" size={14} />
      <span>Table</span>
    </button>
    <button type="button" role="tab" aria-selected={view === 'ready'} className={`header-toolbar-tab${view === 'ready' ? ' active' : ''}`} onClick={() => onChange('ready')} title="Shipments with goods ready to receive">
      <Icon name="package" size={14} />
      <span>Ready to receive{readyCount > 0 ? ` (${readyCount})` : ''}</span>
    </button>
  </div>
);

export default ShipmentsViewTabs;
